import { render, staticRenderFns } from "./HomePageNoCodeTest.vue?vue&type=template&id=bc4faabe&scoped=true&"
import script from "./HomePageNoCodeTest.vue?vue&type=script&lang=js&"
export * from "./HomePageNoCodeTest.vue?vue&type=script&lang=js&"
import style0 from "./HomePageNoCodeTest.vue?vue&type=style&index=0&id=bc4faabe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc4faabe",
  null
  
)

export default component.exports